import { authorizedFetch } from './api-client';
import { Notification } from '@/types/notification';
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

export async function fetchNotifications(filters: any): Promise<Notification[]> {
  const params = new URLSearchParams();

  params.append('page', (filters.page || 1).toString());
  params.append('pageSize', (filters.pageSize || 20).toString());

  if (filters.clinicId && filters.clinicId !== 'all') params.append('clinic_id', filters.clinicId); // ← NOVO
  if (filters.startDate) params.append('startDate', filters.startDate);
  if (filters.endDate) params.append('endDate', filters.endDate);
  if (filters.status && filters.status !== 'all') params.append('status', filters.status);
  if (filters.category && filters.category !== 'all') params.append('category', filters.category);
  if (filters.searchTerm) params.append('searchTerm', filters.searchTerm);

  const response = await authorizedFetch(`${API_BASE_URL}/api/v1/notifications/?${params.toString()}`);

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Erro ao buscar notificações');
  }

  return response.json();
}

export async function resendNotification(id: string): Promise<void> {
  const response = await authorizedFetch(`${API_BASE_URL}/api/v1/notifications/${id}/resend`, {
    method: 'POST',
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Erro ao reenviar notificação');
  }
}

export async function resetErrorNotification(id: string): Promise<void> {
  const response = await authorizedFetch(`${API_BASE_URL}/api/v1/notifications/${id}/reset-error`, {
    method: 'POST',
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Erro ao resetar notificação');
  }
}

export async function reviewNotification(id: string): Promise<void> {
  const response = await authorizedFetch(`${API_BASE_URL}/api/v1/notifications/${id}/review`, {
    method: 'POST',
  });
  if (!response.ok && response.status !== 204) {
    const error = await response.json();
    throw new Error(error.detail || 'Erro ao marcar como revisada');
  }
}

export async function unreviewNotification(id: string): Promise<void> {
  const response = await authorizedFetch(`${API_BASE_URL}/api/v1/notifications/${id}/unreview`, {
    method: 'POST',
  });
  if (!response.ok && response.status !== 204) {
    const error = await response.json();
    throw new Error(error.detail || 'Erro ao reverter para revisão');
  }
}